import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router, UrlTree, ActivatedRoute, Params } from '@angular/router';
import { SnackService } from '@shared/services/snack.service';
import { Title } from '@angular/platform-browser';
import { ApiService } from '@shared/services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@shared/services/auth.service';
import { ViewportService } from '@shared/services/viewport.service';
import { LocaleService } from '@shared/services/locale.service';
import { NumbersService } from '@shared/services/numbers.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';
import imageCompression from 'browser-image-compression';
import { AdsService } from '@shared/services/ads.service';
import { AuthFacade } from '../../auth/auth.facade';
import { User } from '@core/models';

@Component({
	selector: 'app-user-edit-ad',
	templateUrl: './user-edit-ad.component.html',
	styleUrls: ['./user-edit-ad.component.scss'],
	providers: [AuthFacade],
})
export class UserEditAdComponent implements OnInit {
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private snack: SnackService,
		private title: Title,
		private api: ApiService,
		private dialog: MatDialog,
		private auth: AuthService,
		public viewport: ViewportService,
		public locale: LocaleService,
		public numbers: NumbersService,
		private httpClient: HttpClient,
		private adsService: AdsService,
		private readonly authFacade: AuthFacade
	) {}

	loading: boolean = true;
	categories = [];
	subcategories = [];
	locations = [];
	popularLocations = [];
	motorData = {};
	electronicData = {};
	models = [];
	images: { url: string | ArrayBuffer; progress: number; uploadID: string; new: boolean; file?: File }[] = [];
	deletedImageID = [];
	coverImage: string;
	formData: FormData = new FormData();
	isMobile: boolean = false;
	isMotor: boolean = false;
	isElectronic: boolean = false;
	user: User = this.auth.user();
	ad: Object;
	isSeller: boolean;
	canExit: boolean = false;
	filterselectedCountryPrefix: any = [];
	selectedCountryPrefix: any = [];
	catIDValue: string;
	subCatIDValue: string;
	form: UntypedFormGroup = new UntypedFormGroup({
		contactTypeWhatsapp: new UntypedFormControl(false, Validators.required),
		contactTypeViber: new UntypedFormControl(false, Validators.required),
		category: new UntypedFormControl(null, Validators.required),
		subcategory: new UntypedFormControl(null, Validators.required),
		location: new UntypedFormControl(null, Validators.required),
		phonePrefix: new UntypedFormControl(this.user ? localStorage.getItem('prefix') : '+964', Validators.required),
		phone: new UntypedFormControl('', [Validators.required, Validators.minLength(11)]),
		title: new UntypedFormControl(null, [Validators.required, Validators.minLength(4), Validators.maxLength(150)]),
		description: new UntypedFormControl(null, [Validators.required, Validators.minLength(5), Validators.maxLength(5000)]),
		price: new UntypedFormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(10)]),
	});

	searchTextCat = new UntypedFormControl('');
	searchTextSubCat = new UntypedFormControl('');
	searchTextBrand = new UntypedFormControl('');
	searchTextModel = new UntypedFormControl('');
	searchTextLocation = new UntypedFormControl('');
	searchTextMake = new UntypedFormControl('');
	searchTextYear = new UntypedFormControl('');
	searchTextColor = new UntypedFormControl('');
	searchTextMemory = new UntypedFormControl('');
	searchTextStorage = new UntypedFormControl('');
	searchTextProcessor = new UntypedFormControl('');
	searchTextGraphics = new UntypedFormControl('');
	searchTextNetwork = new UntypedFormControl('');

	// @ViewChildren('imageCont') imgCont: QueryList<ElementRef>;

	onClearSearch(searchTextControl: UntypedFormControl) {
		//for brand and make we are reseting searchTextBrand and searchTextModel from brandSelection(),makeSelection() function
		setTimeout(() => {
			searchTextControl.setValue('');
		});
	}

	onSelect(id: any) {
		localStorage.setItem('adPrefix', id);
		this.form.get('phonePrefix').setValue(id);
	}
	onKey(value) {
		value == '' ? (this.filterselectedCountryPrefix = this.selectedCountryPrefix) : (this.filterselectedCountryPrefix = this.search(value));
	}

	search(value: string) {
		let filter = value.toLowerCase();
		return this.selectedCountryPrefix.filter((option) => option.name.toLowerCase().includes(filter));
	}

	onMakeSelection(makeID: string) {
		this.form.get('model').reset();
		this.loading = true;

		let formData: FormData = new FormData();
		formData.append('makeID', makeID);
		formData.append('lang', this.locale.lang);

		this.api.models(formData).subscribe((res) => {
			if (res['status'] === '1') {
				this.models = res['response'];
			} else {
				this.snack.open(this.locale.translations['ads']['filter']['s2']);
			}

			this.loading = false;
		});
	}

	onBrandSelection(brandID: string) {
		this.form.get('eModel').reset();
		this.loading = true;

		let formData: FormData = new FormData();
		formData.append('brandID', brandID);
		formData.append('subCatID', this.form.get('subcategory').value);
		formData.append('lang', this.locale.lang);

		this.api.electronicModels(formData).subscribe((res) => {
			if (res['status'] === '1') {
				this.models = res['response'];
			} else {
				this.snack.open(this.locale.translations['ads']['filter']['s2']);
			}

			this.loading = false;
		});
	}

	generateMotorTitle(makeID: string, modelID: string, year: string): string {
		let make: string = '';
		let model: string = '';

		// find make name by id
		(<[any]>this.motorData['makes']).forEach((_make) => {
			if ((<number>_make['id']).toString() === makeID) {
				make = (<number>_make['name']).toString();
			}
		});

		// find model name by id
		this.models.forEach((_model) => {
			if ((<number>_model['id']).toString() === modelID) {
				model = _model['name'];
			}
		});

		return make + ' ' + model + ' ' + year;
	}

	generateElectronicTitle(brandID: string, modelID: string): string {
		let eBrand: string = '';
		let eModel: string = '';
		// find brand name by id
		(<[any]>this.electronicData['brands']).forEach((_eBrand) => {
			if ((<number>_eBrand['id']).toString() === brandID) {
				eBrand = (<number>_eBrand['name']).toString();
			}
		});

		// find model name by id
		this.models.forEach((_eModel) => {
			if ((<number>_eModel['id']).toString() === modelID) {
				eModel = _eModel['name'];
			}
		});

		return eBrand + ' ' + eModel;
	}

	onSubmit() {
		this.loading = true;
		let formData: FormData = new FormData();
		let updatedTitle;

		// images
		this.images.forEach((image) => {
			if (image['new']) {
				formData.append('uploadImageIDs[]', image['uploadID']);
			}
		});

		if (this.coverImage !== undefined) {
			formData.append('coverImage', this.coverImage);
		}

		//To check whether its a test number then retrieve actual number else save same number
		const ORIGINAL_PHONE_NUMBER = this.authFacade.getTestPhoneNumber(this.form.get('phone').value.substring(2));

		// standard data
		let contactTypeWhatsapp = this.form.get('contactTypeWhatsapp').value ? '1' : '0';
		let contactTypeViber = this.form.get('contactTypeViber').value ? '1' : '0';
		formData.append('contactTypeWhatsapp', contactTypeWhatsapp);
		formData.append('contactTypeViber', contactTypeViber);
		formData.append('lang', this.locale.lang);
		formData.append('platform', 'Web');
		formData.append('adID', this.ad['data']['adID']);
		formData.append('userID', this.user['userID']);

		if (this.isMotor) {
			updatedTitle = this.generateMotorTitle(this.form.get('make').value, this.form.get('model').value, this.form.get('year').value);
		} else if (this.isElectronic) {
			updatedTitle = this.generateElectronicTitle(this.form.get('eBrand').value, this.form.get('eModel').value);
		} else {
			updatedTitle = this.form.get('title').value;
		}

		formData.append('title', updatedTitle);

		// formData.append('title', this.isMotor ? this.generateMotorTitle(this.form.get('make').value, this.form.get('model').value, this.form.get('year').value) : this.form.get('title').value);
		formData.append('catID', this.form.get('category').value);
		formData.append('subCatID', this.form.get('subcategory').value);
		formData.append('phone', ORIGINAL_PHONE_NUMBER);
		formData.append('description', this.form.get('description').value);
		formData.append('price', this.form.get('price').value);
		formData.append('phonePrefix', this.form.get('phonePrefix').value);
		formData.append('locationID', this.form.get('location').value);

		// motor data
		if (this.isMotor) {
			formData.append('motorMakeID', this.form.get('make').value);
			formData.append('motorModelID', this.form.get('model').value);
			formData.append('motorYear', this.form.get('year').value);
			formData.append('motorColorID', this.form.get('color').value);
		}

		// electronic data
		if (this.isElectronic) {
			formData.append('electronicBrandID', this.form.get('eBrand').value);
			formData.append('electronicModelID', this.form.get('eModel').value);
			formData.append('electronicColorID', this.form.get('eColor').value);
			formData.append('electronicStorageID', this.form.get('eStorage').value);
			formData.append('electronicMemoryID', this.form.get('eMemory').value);
			formData.append('electronicProcessorID', this.form.get('eProcessor').value);
			formData.append('electronicGraphicsID', this.form.get('eGraphic').value);
			formData.append('electronicNetworkID', this.form.get('eNetwork').value);
		}

		// api call
		this.api.editAd(formData).subscribe((res) => {
			if (res['status'] === '1') {
				this.canExit = true;

				if (this.deletedImageID.length > 0) {
					const deleteImagesFormData: FormData = new FormData();
					deleteImagesFormData.append('lang', this.locale.lang);
					deleteImagesFormData.append('adID', this.ad['data']['adID']);
					deleteImagesFormData.append('userID', this.ad['data']['userID']);
					this.deletedImageID.forEach((id, index) => {
						deleteImagesFormData.append('imageID', id);

						this.api.deleteImage(deleteImagesFormData).subscribe((res) => {
							this.loading = false;

							if (index === this.deletedImageID.length - 1) {
								this.snack.open(this.locale.translations['user']['user-ads']['edit-ad']['s17']);
								setTimeout(() => {
									this.router.navigate(['/ad/' + this.ad['data']['adID']]);
								});
							}
						});
					});
				} else {
					this.loading = false;

					this.adsService.editAdDescription = this.form.value.description;
					this.adsService.editAdTitle = updatedTitle;
					this.adsService.isEditAd = true;

					this.snack.open(this.locale.translations['user']['user-ads']['edit-ad']['s17']);
					setTimeout(() => {
						this.router.navigate(['/ad/' + this.ad['data']['adID']]);
					});
				}
			} else {
				this.snack.open(res['message']);
			}
		});
	}

	onCategorySelection(catID: string) {
		// fetch subcategories

		this.categories.forEach((category) => {
			if (category['id'] === catID) {
				this.subcategories = category['subCategories'];
			}
		});

		this.form.get('subcategory').reset();
	}

	onSubcategorySelection(subCatID: string) {
		// add motor data if needed
		if (this.form.get('category').value === '15' && subCatID === '291') {
			this.loading = true;

			this.form.addControl('make', new UntypedFormControl(null, Validators.required));
			this.form.addControl('model', new UntypedFormControl(null, Validators.required));
			this.form.addControl('year', new UntypedFormControl(null, Validators.required));
			this.form.addControl('color', new UntypedFormControl(null, Validators.required));

			let motorFormData: FormData = new FormData();
			motorFormData.append('lang', this.locale.lang);

			this.api.motorData(motorFormData).subscribe((res) => {
				if (res['status'] === '1') {
					this.motorData = res['response'];

					this.form.get('make').setValue(this.ad['data']['motorMakeID']);
					this.onMakeSelection(this.ad['data']['motorMakeID']);
					this.form.get('model').setValue(this.ad['data']['motorModelID']);
					this.form.get('year').setValue(this.ad['data']['motorYear']);
					this.form.get('color').setValue(this.ad['data']['motorColorID']);

					this.isMotor = true;

					this.form.removeControl('title');
				} else {
					this.snack.open(this.locale.translations['ads']['filter']['s4']);
				}

				this.loading = false;
			});
		} else if (
			this.form.get('category').value === '16' &&
			(subCatID === '302' ||
				subCatID === '303' ||
				subCatID === '304' ||
				subCatID === '305' ||
				subCatID['value'] === '306' ||
				subCatID === '307' ||
				subCatID === '308' ||
				subCatID === '309' ||
				subCatID === '310' ||
				subCatID === '311' ||
				subCatID === '312' ||
				subCatID === '313' ||
				subCatID === '365' ||
				subCatID === '366' ||
				subCatID === '367' ||
				subCatID === '370' ||
				subCatID === '371' ||
				subCatID === '372' ||
				subCatID === '373')
		) {
			this.loading = true;
			this.form.addControl('eBrand', new UntypedFormControl(null, Validators.required));
			this.form.addControl('eModel', new UntypedFormControl(null));
			this.form.addControl('eColor', new UntypedFormControl(null, Validators.required));
			this.form.addControl('eStorage', new UntypedFormControl(null));
			this.form.addControl('eMemory', new UntypedFormControl(null));
			this.form.addControl('eProcessor', new UntypedFormControl(null));
			this.form.addControl('eGraphic', new UntypedFormControl(null));
			this.form.addControl('eNetwork', new UntypedFormControl(null));

			// fetch data
			let ElectronicFormData: FormData = new FormData();
			ElectronicFormData.append('lang', this.locale.lang);

			this.api.electronicFilterData(ElectronicFormData).subscribe((res) => {
				if (res['status'] === '1') {
					this.electronicData = res['response'];
					this.form.get('eBrand').setValue(this.ad['data']['electronicBrandID']);
					this.onBrandSelection(this.ad['data']['electronicBrandID']);
					this.form.get('eModel').setValue(this.ad['data']['electronicModelID']);
					this.form.get('eColor').setValue(this.ad['data']['electronicColorID']);
					this.form.get('eStorage').setValue(this.ad['data']['electronicStorageID']);
					this.form.get('eMemory').setValue(this.ad['data']['electronicMemoryID']);
					this.form.get('eProcessor').setValue(this.ad['data']['electronicProcessorID']);
					this.form.get('eGraphic').setValue(this.ad['data']['electronicGraphicsID']);
					this.form.get('eNetwork').setValue(this.ad['data']['electronicNetworkID']);

					this.isElectronic = true;

					this.form.removeControl('title');
				} else {
					this.snack.open(this.locale.translations['ads']['filter']['s4']);
				}
			});
		}

		// this.form.addControl('title', new FormControl(null, Validators.required));
		else {
			this.loading = false;
			this.form.addControl('title', new UntypedFormControl(null, Validators.required));
			this.isElectronic = false;
			this.isMotor = false;
			this.form.removeControl('eBrand');
			this.form.removeControl('eModel');
			this.form.removeControl('eColor');
			this.form.removeControl('eStorage');
			this.form.removeControl('eMemory');
			this.form.removeControl('eProcessor');
			this.form.removeControl('eGraphic');
			this.form.removeControl('eNetwork');
			this.form.removeControl('make');
			this.form.removeControl('model');
			this.form.removeControl('year');
			this.form.removeControl('color');
		}
	}

	onImageFileSelection($event) {
		const NEW_FILE = $event.target.files[0];
		const EXISTING_IMAGES = this.images.map((image) => image?.file?.name);

		for (let index = 0; index < $event['target']['files'].length; index++) {
			// Check if the file already exists in the images array
			if (EXISTING_IMAGES.includes(NEW_FILE.name)) {
				this.snack.open('this file is already uploaded');
				return; // Skip uploading the duplicate image
			}

			if (this.images.length + index >= 10) {
				this.snack.open(this.locale.translations['place-ad']['photos']['n175']);
				return;
			}

			const file = $event['target']['files'][index];

			const fileReader: FileReader = new FileReader();
			fileReader.onloadend = async () => {
				const current = this.images.push({ url: fileReader.result, progress: null, uploadID: null, new: true, file: file }) - 1;
				let compressFile = await this.handleImageUpload(file);
				const imageFormData: FormData = new FormData();
				imageFormData.append('lang', this.locale.lang);
				imageFormData.append('image', compressFile, compressFile['name']);
				imageFormData.append('adID', this.ad['data']['adID']);
				imageFormData.append('phonePrefix', this.form.get('phonePrefix').value);
				imageFormData.append('phone', this.form.get('phone').value);
				imageFormData.append('expressAd', index === 0 ? '1' : '');
				imageFormData.append('rotateImage', '0');

				this.api.uploadImageRaw(imageFormData).subscribe(
					(event) => {
						if (event['type'] === HttpEventType.UploadProgress) {
							this.images[current]['progress'] = Math.round((event['loaded'] / event['total']) * 100);
						} else if (event['type'] === HttpEventType.Response) {
							if (event['body']['status'] === '1') {
								this.images[current]['uploadID'] = event['body']['response']['uploadID'];
								this.images[current]['url'] = event['body']['response']['path'];
							}
						}
					},
					(err) => {
						this.onImageDelete(current);
						console.log('Oops, image failed to upload.', err);
					}
				);
			};

			fileReader.readAsDataURL(file);
		}
	}

	onImageCover(index: number) {
		this.coverImage = this.images[index]['uploadID'];
	}

	onImageDelete(index: number) {
		if (this.images[index]['uploadID'] === this.coverImage) {
			this.coverImage = undefined;
		}

		this.deletedImageID.push(this.images[index]['uploadID']);

		this.images.splice(index, 1);
	}

	imagesUploaded(): boolean {
		return this.images.every((image) => image['progress'] === 100);
	}

	onPriceKeyUp() {
		this.form.get('price').setValue(this.numbers.toNumeric(this.form.get('price').value.toString().replace(/\s/g, '')));
	}

	onPhoneKeyUp() {
		if (this.form.get('phone').value !== null) {
			let phoneNumber = this.numbers.toNumeric(this.form.get('phone').value.toString().replace(/\s/g, ''));

			// Ensure "07" prefix is always there
			if (!phoneNumber.startsWith('07')) {
				phoneNumber = '07' + phoneNumber;
			}

			if (phoneNumber.charAt(2) === '0') {
				phoneNumber = phoneNumber.slice(0, 2) + phoneNumber.slice(3);
			}

			if (phoneNumber.charAt(0) !== '0') {
				phoneNumber = '0' + phoneNumber;
			}

			this.form.get('phone').setValue(phoneNumber);
		}
	}

	isNumberKey(evt) {
		let charCode = evt.which ? evt.which : evt.keyCode;

		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			//this.invalidMobile = false;
			return false;
		}

		return true;
	}

	canDeactivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		if (!this.form.dirty || this.canExit) {
			return true;
		}

		const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
			width: '250px',
			height: '120px',
			data: {
				message: this.locale.translations['place-ad']['n162'],
				yes: this.locale.translations['user']['user-ads']['delete-ad']['n89'],
				no: this.locale.translations['user']['user-ads']['delete-ad']['n90'],
			},
		});

		return dialogRef.afterClosed();
	}

	rotateImageDiv(e, index, setBase64) {
		e.stopImmediatePropagation();
		var canvas = document.getElementById('canvas') as any;
		var ctx = canvas.getContext('2d');
		var image = new Image();
		image.setAttribute('crossOrigin', 'anonymous');
		image.src = this.images[index].url as any;
		image.onload = function () {
			canvas.height = image.width;
			canvas.width = image.height;
			image.width = canvas.width;
			image.height = canvas.height;
			ctx.translate(image.width, image.height / image.width);
			ctx.rotate(Math.PI / 2);
			ctx.drawImage(image, 0, 0);
			setBase64(canvas.toDataURL());
			ctx.restore();
			image = null;
		};
	}

	getBase64(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = (error) => reject(error);
		});
	}

	rotateImage($event, index) {
		this.rotateImageDiv($event, index, async (url) => {
			this.deletedImageID.push(this.images[index]['uploadID']);
			this.images[index].url = url;
			let blob = await this.dataURLtoBlob(url);
			this.images[index] = { url: url, progress: null, uploadID: null, new: true };
			let compressFile = await this.handleImageUpload(blob);
			const imageFormData: FormData = new FormData();
			imageFormData.append('lang', this.locale.lang);
			imageFormData.append('image', compressFile, 'xyz');
			imageFormData.append('rotateImage', '1');

			this.api.uploadImageRaw(imageFormData).subscribe(
				(event) => {
					if (event['type'] === HttpEventType.UploadProgress) {
						this.images[index]['progress'] = Math.round((event['loaded'] / event['total']) * 100);
					} else if (event['type'] === HttpEventType.Response) {
						if (event['body']['status'] === '1') {
							this.images[index]['uploadID'] = event['body']['response']['uploadID'];
						}
					}
				},
				(err) => {
					this.onImageDelete(index);
					console.log('Oops, image failed to upload.', err);
				}
			);
		});
	}

	async dataURLtoBlob(dataurl) {
		var arr = dataurl.split(','),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);

		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}

		return new Blob([u8arr], { type: mime });
	}

	setRotateImage(canvasUrl, index) {
		this.images[index].url = canvasUrl;
	}

	async handleImageUpload(event) {
		const imageFile = event;
		const options = {
			maxSizeMB: 2,
			maxWidthOrHeight: 1920,
			useWebWorker: true,
		};

		try {
			const compressedFile = await imageCompression(imageFile, options);
			return compressedFile;
		} catch (error) {
			console.log(error);
		}
	}

	autoFocus() {
		const searchbox = document.getElementById('searchbox');
		if (searchbox && this.viewport.type === 'desktop') {
			searchbox.focus();
		}
	}

	ngOnInit(): void {
		this.httpClient.get<any>('./assets/country_dial_info.json').subscribe((data) => {
			this.selectedCountryPrefix = data;
			this.filterselectedCountryPrefix = data;
		});

		this.title.setTitle(this.locale.translations['user']['user-ads']['n84'] + ' | ' + this.locale.translations['header']['n0']);
		// fetch ad data
		this.route.params.subscribe((params: Params) => {
			this.formData.append('userID', this.user['userID']);
			this.formData.append('adID', params['id']);
			this.formData.append('lang', this.locale.lang);

			this.api.ad(this.formData).subscribe((res) => {
				this.ad = res['response'];

				const ORIGINAL_NUMBER = this.authFacade.getOriginalPhoneNumber(this.ad['data']['phone']);
				this.catIDValue = this.ad['data']['catID'];
				this.subCatIDValue = this.ad['data']['subCatID'];

				this.isSeller = this.user && this.user['userID'] === this.ad['seller']['id'];
				let whatsapp = this.ad['data']['contactTypeWhatsapp'] == '1' ? true : false;
				let viber = this.ad['data']['contactTypeViber'] == '1' ? true : false;
				this.form.get('contactTypeWhatsapp').setValue(whatsapp);
				this.form.get('contactTypeViber').setValue(viber);
				this.form.get('title').setValue(this.ad['data']['title']);
				this.form.get('description').setValue(this.ad['data']['description']);
				const PRICE = this.ad['data']['price'].replace(/,/g, '');
				this.form.get('price').setValue(PRICE);
				this.form.get('phone').setValue(ORIGINAL_NUMBER);
				this.form.get('phonePrefix').setValue(this.ad['data']['phonePrefix']);

				this.ad['images'].forEach((image) => {
					if (image['coverImage'] === '1') {
						this.coverImage = image['id'];
					}

					this.images.push({ url: image['name'], progress: 100, uploadID: image['id'], new: false });
				});

				// fetch categories
				let catFormData: FormData = new FormData();
				catFormData.append('lang', this.locale.lang);

				this.api.categories(catFormData).subscribe((res) => {
					this.categories = res['response'];
					if (this.ad['data']['catID']) {
						this.form.get('category').setValue(this.ad['data']['catID']);
						this.onCategorySelection(this.ad['data']['catID']);
						this.form.get('subcategory').setValue(this.ad['data']['subCatID']);
						this.onSubcategorySelection(this.ad['data']['subCatID']);
					}
					// fetch locations
					let locFormData: FormData = new FormData();
					locFormData.append('lang', this.locale.lang);
					this.api.locations(locFormData).subscribe((res) => {
						if (res['status'] === '1') {
							this.locations = res['response'];

							this.locations.forEach((location) => {
								if (location['id'] === '82' || location['id'] === '83' || location['id'] === '85' || location['id'] === '89') {
									this.popularLocations.push(location);
								}
							});

							this.locations = this.locations.filter((location) => {
								return !(location['id'] === '82' || location['id'] === '83' || location['id'] === '85' || location['id'] === '89');
							});
						} else {
							this.snack.open(this.locale.translations['ads']['filter']['s3']);
						}

						this.form.get('location').setValue(this.ad['data']['locationID'].toString());
						this.loading = false;
					});
				});
			});
		});
	}
}
